<div class="container-fluid">
    <app-common-inputs></app-common-inputs>
    <app-results></app-results>
</div>
